import { render } from "./CorreoInput.vue?vue&type=template&id=9979f05e&scoped=true"
import script from "./CorreoInput.vue?vue&type=script&lang=js"
export * from "./CorreoInput.vue?vue&type=script&lang=js"

import "./CorreoInput.vue?vue&type=style&index=0&id=9979f05e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9979f05e"]])

export default __exports__